// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalLeafFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.558 15.721a.436.436 0 0 1-.211-.113C-.23 13.118-.69 9.43 1.286 6.804a8.035 8.035 0 0 1 3.086-2.507c.932-.44 1.783-.693 3.399-1.074l.204-.048c3.188-.75 4.495-1.325 5.82-2.951a.438.438 0 0 1 .748.119c1.72 4.475.969 8.839-2.31 12.517-1.455 1.632-3.884 2.838-5.911 3.213a7.176 7.176 0 0 1-.197.052c-1.454.363-2.88-.071-3.567-.404Zm-.372 3.812a.438.438 0 0 1-.872-.066c.199-2.637.981-4.912 2.301-6.982 1.053-1.652 2.349-3.065 4.245-4.78.34-.306 2.318-2.04 2.843-2.526a.438.438 0 0 1 .594.642c-.535.495-2.518 2.234-2.85 2.534-3.992 3.607-5.918 6.627-6.26 11.178Z"
			fill="#fff"
		/>
	</svg>
);
export default GoalLeafFilled;
